import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { DashboardLayout } from "@/components/DashboardLayout";

import LandingPage from "@/pages/LandingPage";
import ChallengesPage from "@/pages/ChallengesPage";
import FaqPage from "@/pages/FaqPage";
import AffiliatePage from "@/pages/AffiliatePage";
import { TermsPage, PoliciesPage, DisclaimerPage } from "@/pages/LegalPages";
import { LoginPage, SignupPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/AuthPages";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import ReferralRedirect from "@/pages/ReferralRedirect";

import { OverviewPage } from "@/pages/dashboard/OverviewPage";
import { AccountsPage } from "@/pages/dashboard/AccountsPage";
import { CertificatesPage } from "@/pages/dashboard/CertificatesPage";
import { PayoutsPage } from "@/pages/dashboard/PayoutsPage";
import { LeaderboardPage } from "@/pages/dashboard/LeaderboardPage";
import { OrdersPage } from "@/pages/dashboard/OrdersPage";
import { ProfilePage } from "@/pages/dashboard/ProfilePage";

import { AdminOverview } from "@/pages/admin/AdminOverview";
import { AdminTraders } from "@/pages/admin/AdminTraders";
import { AdminOrders } from "@/pages/admin/AdminOrders";
import { AdminAccounts } from "@/pages/admin/AdminAccounts";
import { AdminPayouts } from "@/pages/admin/AdminPayouts";
import { AdminCertificates } from "@/pages/admin/AdminCertificates";
import { AdminBroadcast } from "@/pages/admin/AdminBroadcast";
import { AdminAffiliate } from "@/pages/admin/AdminAffiliate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "rgba(10, 10, 10, 0.95)",
                border: "1px solid rgba(255, 122, 0, 0.3)",
                color: "#f5f5f5",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/challenges" element={<ChallengesPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/affiliate" element={<AffiliatePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/policies" element={<PoliciesPage />} />
            <Route path="/privacy" element={<PoliciesPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/r/:code" element={<ReferralRedirect />} />

            <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<OverviewPage />} />
              <Route path="/dashboard/accounts" element={<AccountsPage />} />
              <Route path="/dashboard/orders" element={<OrdersPage />} />
              <Route path="/dashboard/certificates" element={<CertificatesPage />} />
              <Route path="/dashboard/payouts" element={<PayoutsPage />} />
              <Route path="/dashboard/affiliate" element={<AffiliatePage />} />
              <Route path="/dashboard/leaderboard" element={<LeaderboardPage />} />
              <Route path="/dashboard/profile" element={<ProfilePage />} />
            </Route>

            <Route element={<ProtectedRoute requireAdmin><DashboardLayout admin /></ProtectedRoute>}>
              <Route path="/admin" element={<AdminOverview />} />
              <Route path="/admin/traders" element={<AdminTraders />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/accounts" element={<AdminAccounts />} />
              <Route path="/admin/payouts" element={<AdminPayouts />} />
              <Route path="/admin/certificates" element={<AdminCertificates />} />
              <Route path="/admin/broadcast" element={<AdminBroadcast />} />
              <Route path="/admin/affiliate" element={<AdminAffiliate />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
